import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { GenericRouteEvent } from 'src/app/types/normalize/generic-route-event.model';
import { RouteEventCardComponent } from '../../../components/route-event-card/route-event-card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './group-details.dialog.html',
  styleUrls: ['./group-details.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonicModule, RouteEventCardComponent, TranslatePipe],
})
export class GroupDetailsDialog {
  @Input() routeEvents: GenericRouteEvent[];

  private readonly modalController = inject(ModalController);

  public onCancel(): void {
    this.modalController.dismiss();
  }

  public routeEventTrackBy(index: number) {
    return index;
  }
}
